import { writable } from "svelte/store";
import { call } from "$lib/Api/Api.svelte";

const types = writable([]);

const typeStore = {
  subscribe: types.subscribe,
  load: (id) => {
    return call("types", "query")
      .then((data) => {
        types.set(data);
      })
      .catch((err) => {});
  },
};

export default typeStore;
